// extracted by mini-css-extract-plugin
module.exports = {"comp":"CompareSelectorNL_comp__1Q7GT"};